import { createTRPCReact } from "@trpc/react-query";
import { AppRouter } from "cadendar-trpc-server";

export const trpc = createTRPCReact<AppRouter>();
